import i18n from '@dms/i18n';

export const TestDriveFuelTankLabels: Record<number, string> = {
  0: i18n.t('entity.testDrive.labels.fuelEmpty'),
  25: '1/4',
  50: '1/2',
  75: '3/4',
  100: i18n.t('entity.testDrive.labels.fuelFull'),
};
